import { useCMS } from "@/src/hook/provider";
import { StrapiComponentType } from "@/src/type";

import { TextBreakpointModule } from "@/src/component/partial/__module__";

import styles from "./Footer.module.scss";
import Link from "next/link";
import { Typography } from "@mui/material";

interface FooterColumnProps {
  column: StrapiComponentType.Partial.FooterColumn;
}

function FooterColumn({ column }: FooterColumnProps) {
  const cms = useCMS();

  /**
   * if the link provided is external do not use the CMS link generator
   */
  function getHref(item: StrapiComponentType.Element.LinkOptional): string {
    if (!item?.optionalHref) {
      return "";
    }
    return item.isExternal ? item.optionalHref : cms.constructLink(item.optionalHref);
  }

  return (
    <div className={styles.footerColumn}>
      <TextBreakpointModule
        id={`footerColumn_${column.id}`}
        text={column.label}
        className={styles.footerColumnLabel}
      />
      <ol>
        {(column.items ?? []).map((item, i) => (
          <li key={i}>
            {item?.optionalHref ? (
              <Link
                href={getHref(item)}
                target={item.target}
                className={styles.footerColumnLink}
              >
                <Typography className={styles.footerColumnItem}>{item.label}</Typography>
              </Link>
            ) : (
              <Typography className={styles.footerColumnItem}>{item.label}</Typography>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
}

export default FooterColumn;
